// extracted by mini-css-extract-plugin
export default {"page":"styles_page_v4eg1"};